import React from 'react';

import { withCommon } from '../../../../components';
import {API_PREFIX} from "../../../../common/api/api-url-config";
import apiUrls from "../../../../common/api/api-urls";

const Lottery = withCommon({
    store: ({ store }) => ({
        viewSize: store.site.status.viewSize,
    }),
    defaultName: 'LotteryPage',
    isObserver: true,
})(({ viewSize }) => {

    return (
        <div className={`ll-page lottery--${viewSize}`}>
            <iframe
                className={`lottery-iframe--${viewSize}`}
                src={`${API_PREFIX}${apiUrls.games.openGame}?providerId=330`}
                title="open-game"
                frameBorder="0"
                allowFullScreen
            />
        </div>
    );
});

export default Lottery;
